export const accountRegex = {
  oneUpperCase: /[A-Z]/,
  oneLowerCase: /[a-z]/,
  isNumberRegx: /\d/,
  oneSpecialRegx: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/
};
